import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";

import WidgetWrapper from "./WidgetWrapper";
import Rendement from "../Rendement";

export default class WidgetRendement extends Component {
  render() {
    const data = this.props.detailData;

    return (
      <WidgetWrapper
        title="Rendement"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {!data ? (
          <Loader />
        ) : data.rendement ? (
          <Rendement data={data} />
        ) : (
          <p className="mt-10 mb-10" style={{ textAlign: "center", color: "#999" }}>
            Aucune donnée disponible
          </p>
        )}
      </WidgetWrapper>
    );
  }
}
